import { defineStore } from 'pinia'

import type { Creative } from '@/types/creative'
import { findCreativeInTree } from '@/helpers/creativeHelper'

interface CreativeState {
  creatives: Creative[]
  selectedCreative: Creative | null
  productCombinations: string[][]
  moreLikeThisReferenceId: string
  currentSlide: number
}
export const useCreativeStore = defineStore('creative', {
  state: (): CreativeState => ({
    creatives: [],
    selectedCreative: null,
    productCombinations: [],
    moreLikeThisReferenceId: '',
    currentSlide: -1,
  }),
  actions: {
    addCreative(creative: Creative) {
      if (creative.parentId) {
        const parentCreative = findCreativeInTree(this.creatives as Creative[], creative.parentId)
        if (parentCreative) {
          parentCreative.subCreatives.push(creative)
        }
      } else {
        this.creatives.push(creative)
      }
    },
    clearCreatives() {
      this.creatives = []
    },
    updateCreative(id: string, parentId: string | null, updatedCreative: Creative) {
      const targetCreative = findCreativeInTree(this.creatives as Creative[], id)
      if (targetCreative) {
        Object.assign(targetCreative, updatedCreative)
      }
    },
    setSelectedCreative(creative: Creative) {
      this.selectedCreative = creative
    },
    setProductCombinations(combinations: string[][]) {
      this.productCombinations = combinations
    },
    resetCreativeState() {
      this.creatives = []
      this.selectedCreative = null
      this.productCombinations = []
      this.moreLikeThisReferenceId = ''
      this.currentSlide = -1
    },
  },
})
